import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const UseStartAssessment = (
  isLoading,
  isStarted,
  transactionStatus,
  //   applicationStatus,
  onYesCallBack,
  onNoCallback = () => { }
) => {
  const isStatusAllowed =
    ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  //   const isApplicationStatusAllowed =
  //     ['FOR PERMIT PROCESS'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isStatusAllowed;

  const onStartAssessment = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to ${isStarted ? 'Stop' : 'Start'} assessment?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = isAllowed ? (
    <button
      disabled={isLoading}
      onClick={onStartAssessment}
      type="button"
      className={`btn ${isStarted ? 'btn-danger' : 'btn-primary cms-bg-color-primary cms-outline-primary'
        } font-weight-bold`}
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      {isStarted ? `Stop` : `Start`} Assessment{' '}
      <i className={`fas ${isStarted ? 'fa-times' : 'fa-check'}`} />
    </button>
  ) : null;

  return {
    isAllowed,
    onStartAssessment,
    component,
  };
};

export default UseStartAssessment;
